export default "__VITE_ASSET__SV$KVOIt__"